import { create } from 'zustand';

interface ProfessionalUpgradeTourState {
  pending: boolean;
  requestTour: () => void;
  clearPending: () => void;
}

export const useProfessionalUpgradeTourStore = create<ProfessionalUpgradeTourState>((set) => ({
  pending: false,
  requestTour: () => set({ pending: true }),
  clearPending: () => set({ pending: false }),
}));
